<template>
  <div class="main-content">
    <el-row :class="isfixed ? 'fixed-page':''">
      <el-col :span="8" style="line-height:40px;">
        <el-dropdown @command="onChangeJob">
          <span class="el-dropdown-link">
            {{postText}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="all">全部职位</el-dropdown-item>
            <el-dropdown-item v-for="job in jobs" :key="job.jobId" :command="job.jobId">{{job.postName}}</el-dropdown-item>            
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <el-col :span="16" style="text-align:right;">
        <el-pagination background @current-change="onCurrentChange" :current-page="currentPage" :page-sizes="[10]"
          :page-size="pageSize" layout="slot, prev, pager, next" :total="total">
          <span class="el-pagination__total">共 {{total}} 条记录</span>
        </el-pagination>
      </el-col>
    </el-row>
    <div v-loading="loading" style="margin-top: 20px; min-height: 112px;">
      <div v-for="talent in talents" :key="talent.meDataId">
        <taCard :talent="talent" :cardType="5" :words="[]" @goto="onGoto(talent)"></taCard>
      </div>
      <div class="nomore" v-if="!loading && jobs.length === 0">当前没有职位，<router-link to="/JobEdit">点击去创建职位</router-link></div>
      <div class="nomore" v-else-if="!loading && talents.length === 0">当前没有推荐人才</div>
    </div>    
  </div>
</template>

<script>
  import {
    getMyNormalList
  } from '~/api/job';
  import {
    getRecommendTalent,
    getRecommendTalentFromUser
  } from '~/api/referral';
  import taCard from './comp_card_long';
  export default {
    components: {
      taCard,
    },
    data() {
      return {
        postText: '全部职位',
        currentPage: 1,
        pageSize: 6,
        total: 0,
        loading: false,
        jobs: [],
        jobId: 0,
        talents: [],
        isfixed: false,
      };
    },
    created() {
      this.$emit('changeMenu', 'TalentIndex');
      this.getPostList();
      this.getTalentList();
    },
    mounted() {
      window.addEventListener('scroll', this.handlePageFix, true);
    },
    methods: {
      handlePageFix() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        var elItem = document.querySelector('.main-content');
        var offsetTop = elItem.offsetTop;
        scrollTop > offsetTop ? this.isfixed = true : this.isfixed = false;
      },
      getPostList(){
        getMyNormalList().then(m => {
          if (m.errcode == 0) {
            this.jobs = m.data;
          }
        });
      },
      getTalentList(){
        this.loading = true;
        if(this.jobId > 0){
          let params = {
            postId: this.jobId,
            pageIndex: this.currentPage - 1,
            pageSize: this.pageSize          
          };
          getRecommendTalent(params).then(r => {
            if(r.errcode === 0){
              this.talents = r.data.list;
              this.total = r.data.total_item_count;
            }            
            this.loading = false;
          });
        } else {
          let params = {
            pageIndex: this.currentPage - 1,
            pageSize: this.pageSize          
          };
          getRecommendTalentFromUser(params).then(r => {
            if(r.errcode === 0){
              this.talents = r.data.list;
              this.total = r.data.total_item_count;
            }
            this.loading = false;
          });
        }
      },
      onChangeJob(val) {
        if(val == 'all'){
          this.jobId = 0;
          this.postText = '全部职位';
        } else {
          var job = this.jobs.find(j => j.jobId == val);
          if (job) {
            this.jobId = job.jobId;
            this.postText = job.postName;
          }
        }
        this.currentPage = 1;
        this.getTalentList();
      },
      onCurrentChange(index) {
        this.currentPage = index;
        this.getTalentList();
      },
      onGoto(talent) {
        let routeData = this.$router.resolve({
          path: '/TalentDetail',
          query: {
            id: talent.resumeId,
            type: talent.resumeType,
            isII: talent.isInsteadInvite,
            jobId: talent.coPostId,
            keyword: '',
          }
        });
        window.open(routeData.href, '_blank');
      },
    }
  };
</script>

<style scoped>
  .main-content {
    text-align: left;
  }
  .nomore{
    padding: 30px;
    background-color: #fff;
  }
</style>